import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const SegmentCohortsEdit = lazy(() =>
  import("@segments/segment-cohorts/edit/SegmentCohortEdit").then((module) => ({
    default: module.SegmentCohortEditNRO,
  }))
);

export const segmentCohortsEditNRO: NavigationRoutingObject = {
  section: "audience",
  Component: SegmentCohortsEdit,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  heading: (t: I18nT<"dashboard-navigation">) => t("segment-cohorts-edit-nro-heading", "Edit Segment Extensions"),
  pageNameForTracking: () => "Edit Segment Extensions",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("segment-cohorts-edit-nro-description", "Edit a segment extension"),
  icon: "nav-system-segment-extensions",
  featureLimitationKeys: ["can_only_view_landing_page_segment_extensions"],
  getDeveloperNavigationAllowed: () => {
    return true;
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/segment_cohorts/segment_cohorts/:appGroupId",
};
